import moment from "moment";
import React from "react";
import Swal from "sweetalert2";
import { UserIcon } from "../../../../../../components/IconsSVG";
import Datatable from "../../../../../../partials/datatable/Datatable";
import { InexApiService } from "../../../../../../services/InexApiService";
import Loading from "../../../../../home/components/Loading";
import { AdminTitle } from "../../../../components/AdminTitle";
import {
  ReportTableCell,
  ReportTableRow,
  TableContainer,
  TableToExcelButton
} from "./style";

const UserReport = props => {
  const api = new InexApiService();
  const params = props.location.search;

  const [loading, setLoading] = React.useState(false);

  const [reportHeaders, setReportHeaders] = React.useState([]);
  const [report, setReport] = React.useState([]);

  const [selected, setSelected] = React.useState([]);

  React.useEffect(() => {
    handleReport();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleReport = React.useCallback(async () => {
    setLoading(true);

    try {
      const response = await api.makeHttpRequest({
        url: "/professional/export" + params
      });

      if (response && response.length > 0) {
        const headers = Object.keys(response[0]).map(item => ({ label: item }));
        const arr = response.map(_ => false);

        setReportHeaders(headers);
        setReport(response);
        setSelected(arr);
      }
    } catch (e) {
      Swal.fire(
        "Erro!",
        e?.response?.data ? e.response.data : "Erro ao gerar relatório.",
        "error"
      );
    }
    setLoading(false);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSelectRow = index => {
    const arr = [...selected];
    arr[index] = !arr[index];
    setSelected(arr);
  };

  const formatRow = (r, index) => {
    return (
      <ReportTableRow
        hover
        tabIndex={-1}
        key={index}
        onClick={() => handleSelectRow(index)}
        style={selected[index] ? { background: "#E4E4E4" } : null}
      >
        {Object.values(r)?.map((item, i) => (
          <ReportTableCell key={i} scope="row">
            {item ? item : "--"}
          </ReportTableCell>
        ))}
      </ReportTableRow>
    );
  };

  return (
    <>
      <Loading isLoading={loading} />
      {report?.length > 0 && (
        <>
          <AdminTitle
            title="Relatório de Profissionais"
            icon={UserIcon}
            disableHeader
          />
          <TableToExcelButton
            table="datatable-table"
            className="export-table-button"
            filename={`Lista de Ativos ${moment().format("DD-MM-YYYY")}`}
            sheet="Tabela 1"
            buttonText="Exportar"
          />
          <TableContainer>
            <Datatable
              className="m-0 p-0"
              headRows={reportHeaders}
              styledTableCell={ReportTableCell}
              styledTableRow={ReportTableRow}
              overflowX="initial"
              formatRow={formatRow}
              rows={report}
              width={props.width}
              hiddenFooterPagination
              cancelReload
              hiddenReload
            />
          </TableContainer>
        </>
      )}
    </>
  );
};

export default UserReport;
